import type { ReactNode } from 'react';

import type { IconName } from '../../../assets/Icon/Icon';
import { styled } from '../../../stitches.config';
import { ChassisBracket } from './ChassisBracket';
import { chassisVars } from './utils';

const ChassisGroupContent = styled('div', {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: `$${chassisVars.gap.slot}`,
});
ChassisGroupContent.displayName = 'ChassisGroupContent';

const ChassisGroupContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$4',
});
ChassisGroupContainer.displayName = 'ChassisGroupContainer';

export type ChassisGroupProps = {
  label?: ReactNode;
  icon?: IconName;
  children?: ReactNode;
};

export function ChassisGroup({ label, icon, children }: ChassisGroupProps) {
  return (
    <ChassisGroupContainer>
      <ChassisBracket label={label} icon={icon} />
      <ChassisGroupContent>{children}</ChassisGroupContent>
    </ChassisGroupContainer>
  );
}
